export const CONTACT_INFO = {
  phone: "+91 9168754481",
  whatsappLink: "https://wa.me/919168754481?text=Hi,%20I%20would%20like%20to%20book%20a%20cab",
  whatsappNumber: "919168754481"
};

export const SERVICES = [
  {
    id: 1,
    title: "Airport Pickup & Drop",
    description: "Reliable pickup and drop service from Goa Airport. Always on time, comfortable rides.",
    icon: "plane"
  },
  {
    id: 2,
    title: "Railway Station Pickup",
    description: "Fast and convenient pickup from railway stations across Goa. Safe and secure.",
    icon: "train"
  },
  {
    id: 3,
    title: "Goa Sightseeing Tours",
    description: "Explore Goa's beautiful beaches, churches, and forts with our experienced local drivers.",
    icon: "map"
  },
  {
    id: 4,
    title: "Full Day Cab Booking",
    description: "Book a cab for the entire day and travel at your own pace. Flexible and affordable.",
    icon: "calendar"
  },
  {
    id: 5,
    title: "Custom Travel Routes",
    description: "Plan your own route and destinations. We'll take you wherever you want to go in Goa.",
    icon: "route"
  }
];

export const WHY_CHOOSE_US = [
  {
    id: 1,
    title: "24/7 Service",
    description: "Available round the clock for all your travel needs in Goa",
    icon: "clock"
  },
  {
    id: 2,
    title: "Clean & Comfortable Cars",
    description: "Well-maintained, air-conditioned vehicles for a pleasant journey",
    icon: "car"
  },
  {
    id: 3,
    title: "Experienced Local Drivers",
    description: "Friendly drivers who know every corner of Goa",
    icon: "userCheck"
  },
  {
    id: 4,
    title: "Transparent Pricing",
    description: "No hidden charges, clear pricing discussed upfront",
    icon: "badge"
  },
  {
    id: 5,
    title: "Fast Booking on WhatsApp",
    description: "Book instantly through WhatsApp - quick and hassle-free",
    icon: "messageCircle"
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "Best taxi service in Goa! On time airport pickup and smooth ride. Driver was very friendly and showed us the best routes.",
    avatar: "PS"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Delhi",
    rating: 5,
    text: "Excellent service for our full day Goa sightseeing. The driver knew all the best spots and was very professional. Highly recommended!",
    avatar: "RK"
  },
  {
    id: 3,
    name: "Sneha Patel",
    location: "Bangalore",
    rating: 5,
    text: "Very comfortable and clean car. Booking through WhatsApp was super easy. Will definitely use again on my next Goa trip!",
    avatar: "SP"
  },
  {
    id: 4,
    name: "Amit Desai",
    location: "Pune",
    rating: 5,
    text: "Reliable and punctual service. They picked us up from the airport exactly on time. Great experience throughout our vacation.",
    avatar: "AD"
  },
  {
    id: 5,
    name: "Kavita Reddy",
    location: "Hyderabad",
    rating: 5,
    text: "Amazing service! The driver was courteous and the pricing was very transparent. No hidden charges at all. Stress-free travel!",
    avatar: "KR"
  },
  {
    id: 6,
    name: "Vikram Singh",
    location: "Jaipur",
    rating: 5,
    text: "Perfect for tourists! They know all the beautiful beaches and tourist spots. Made our Goa vacation memorable. Thank you!",
    avatar: "VS"
  }
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1494233892892-84542a694e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjb2FzdGFsJTIwcm9hZHxlbnwwfHx8fDE3NzAxMzU0NTh8MA&ixlib=rb-4.1.0&q=85",
  heroSecondary: "https://images.unsplash.com/photo-1460627390041-532a28402358?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxiZWFjaCUyMHN1bnNldHxlbnwwfHx8fDE3NzAxMzU0NjV8MA&ixlib=rb-4.1.0&q=85",
  services: {
    taxi: "https://images.unsplash.com/photo-1642331395578-62fc20996c2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxjb21mb3J0YWJsZSUyMHRheGl8ZW58MHx8fHwxNzcwMTM1NDkyfDA&ixlib=rb-4.1.0&q=85",
    airport: "https://images.unsplash.com/photo-1658942445212-8781e4c66b06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxhaXJwb3J0JTIwdGF4aXxlbnwwfHx8fDE3NzAxMzU1MTB8MA&ixlib=rb-4.1.0&q=85",
    professional: "https://images.unsplash.com/photo-1562253260-523124cc8d9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxhaXJwb3J0JTIwdGF4aXxlbnwwfHx8fDE3NzAxMzU1MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  attractions: {
    cathedral: "https://images.unsplash.com/photo-1727648148276-5c3c47936ca4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxHb2ElMjB0b3VyaXN0JTIwYXR0cmFjdGlvbnN8ZW58MHx8fHwxNzcwMTM1NTQxfDA&ixlib=rb-4.1.0&q=85",
    village: "https://images.unsplash.com/photo-1756797171579-a18cc61c75e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxHb2ElMjB0b3VyaXN0JTIwYXR0cmFjdGlvbnN8ZW58MHx8fHwxNzcwMTM1NTQxfDA&ixlib=rb-4.1.0&q=85",
    fort: "https://images.unsplash.com/photo-1769085027144-d94c14979237?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxHb2ElMjB0b3VyaXN0JTIwYXR0cmFjdGlvbnN8ZW58MHx8fHwxNzcwMTM1NTQxfDA&ixlib=rb-4.1.0&q=85",
    beach: "https://images.unsplash.com/photo-1597820334272-af87b2d917c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxHb2ElMjBzaWdodHNlZWluZ3xlbnwwfHx8fDE3NzAxMzU1NTF8MA&ixlib=rb-4.1.0&q=85"
  }
};
